<div
  class="tw-size-full tw-bg-secondary-100 tw-animate-pulse"
  [ngClass]="{
    'tw-rounded': edgeShape() === 'box',
    'tw-rounded-full': edgeShape() === 'circle',
  }"
  aria-hidden="true"
></div>
